import React, { useMemo } from 'react';

import { TeamLeaderboardTableData } from '../../../../../types/common.types';
import { TeamLeaderboard as TeamLeaderboardType } from '../../../../../types/entity.types';

import { isEmpty } from '../../../../../utils/util';

import Button from '../../../../common/button/Button';
import Table from '../../../../common/table/Table';

import './leaderboard.scss';

const DATA_TEMPLATE: TeamLeaderboardTableData = {
  '#': '',
  team: '',
  'weight(%)': '',
  "cm's": '',
  steps: '',
  objectives: '',
  points: ''
};

type Props = {
  leaderboard?: TeamLeaderboardType;
  downloadExcel: () => void;
};

const TeamLeaderboard = ({ leaderboard, downloadExcel }: Props) => {
  const scores = useMemo(() => {
    if (!leaderboard?.teamScores) return [];

    return leaderboard.teamScores.map((score, index) => ({
      '#': index + 1,
      team: score.teamName,
      'weight(%)': score.weight.toString(),
      "cm's": score.cm.toString(),
      steps: score.steps.toString(),
      objectives: score.objectives.toString(),
      points: score.points.toString()
    }));
  }, [leaderboard]);

  const renderTableBottomActions = () => (
    <div className="leaderboard__table-bottom-actions">
      <Button text="Download .xlsx" onClick={downloadExcel} disabled={isEmpty(scores)} />
    </div>
  );

  return (
    <section className="leaderboard">
      <section className="leaderboard__overview">
        <section className="leaderboard__overview__winner">
          <p>Overall Winner:</p>
          <div>
            <p>{leaderboard?.overallWinnerTeamName ?? 'N/A'}</p>
            <p>{leaderboard?.overallWinnerAmount ?? '0'} pts</p>
          </div>
        </section>
        <section className="leaderboard__overview__stats">
          <div className="leaderboard__overview__stat">
            <p>Most weight lost (%):</p>
            <p>{leaderboard?.mostWeightTeamName ?? 'N/A'}</p>
            <p>{leaderboard?.mostWeightPercentage ?? '0'}%</p>
          </div>
          <div className="leaderboard__overview__stat">
            <p>Most cm's lost:</p>
            <p>{leaderboard?.mostCMsTeamName ?? 'N/A'}</p>
            <p>{leaderboard?.mostCMsAmount ?? '0'} cm</p>
          </div>
          <div className="leaderboard__overview__stat">
            <p>Most Steps:</p>
            <p>{leaderboard?.mostStepsTeamName ?? 'N/A'}</p>
            <p>{leaderboard?.mostStepsAmount ?? '0'} steps</p>
          </div>
          <div className="leaderboard__overview__stat">
            <p>Most Objectives Met:</p>
            <p>{leaderboard?.mostObjectivesTeamName ?? 'N/A'}</p>
            <p>{leaderboard?.mostObjectivesAmount ?? '0'} objectives</p>
          </div>
        </section>
      </section>
      <Table
        data={scores}
        dataTemplate={DATA_TEMPLATE}
        rowsPerPage={10}
        bottomActions={renderTableBottomActions()}
        filter
      />
    </section>
  );
};

export default TeamLeaderboard;
